import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "@/hooks/useTranslation";

export function UserSettingLanguage() {
  const { t, currentLanguage, changeLanguage } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("settings.language.title")}</CardTitle>
        <CardDescription>{t("settings.language.description")}</CardDescription>
      </CardHeader>
      <CardContent>
        <Select
          value={currentLanguage}
          onValueChange={(value) => changeLanguage(value as "en" | "fr")}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder={t("settings.language.placeholder")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="fr">{t("settings.language.french")}</SelectItem>
            <SelectItem value="en">{t("settings.language.english")}</SelectItem>
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
}
